import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Admin-only gate. Wrap any route element that should never be accessible to
 * staff users via direct URL (e.g., /branches, /packages).
 */
export default function AdminRoute({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
